var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8.186 24V13.2h3.278L12 8.4H8.186V6.062c0-1.236.031-2.462 1.758-2.462h1.75V.168C11.694.117 10.19 0 8.67 0 5.496 0 3.508 1.989 3.508 5.64V8.4H0v4.8h3.508V24h4.678z"}));
}

Facebook.defaultProps = {"width":"12","height":"24","viewBox":"0 0 12 24"};

module.exports = Facebook;

Facebook.default = Facebook;
